export const tableShellSx = {
  width: '100%',
  mx: 'auto',
  boxSizing: 'border-box',
  mb: 2
};

export const tableContainedShellSx = {
  width: '100%',
  mx: 'auto',
  boxSizing: 'border-box',
  mb: 2
};

export const responsiveTableContainerSx = {
  width: '100%',
  overflowX: 'auto',
  overflowY: 'hidden',
  '& .MuiTable-root': {
    width: '100%',
    minWidth: {
      xs: 720,
      sm: 900,
      md: 1100
    },
    tableLayout: {
      xs: 'auto',
      lg: 'auto'
    }
  },
  '& .MuiTableCell-root, & th, & td': {
    whiteSpace: 'normal',
    overflowWrap: 'break-word',
    wordBreak: 'normal',
    writingMode: 'horizontal-tb',
    textOrientation: 'mixed',
    transform: 'none',
    verticalAlign: 'top',
    textAlign: 'left',
    px: {
      xs: 1,
      sm: 1.5
    },
    py: {
      xs: 1,
      sm: 1.25
    }
  },
  '& .table-cell-truncate': {
    display: 'inline',
    maxWidth: 'none',
    whiteSpace: 'normal',
    overflow: 'visible',
    textOverflow: 'clip',
    overflowWrap: 'break-word',
    wordBreak: 'normal'
  },
  '& .table-actions-cell': {
    whiteSpace: 'nowrap',
    width: 1,
    minWidth: 120,
    textAlign: 'right'
  },
  '& .table-actions-cell .MuiButton-root, & .table-actions-cell .MuiIconButton-root': {
    flexShrink: 0
  },
  '& .MuiChip-root': {
    maxWidth: '100%'
  },
  '&::-webkit-scrollbar': {
    height: 8
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'rgba(0,0,0,.08)',
    borderRadius: 4
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(0,0,0,.28)',
    borderRadius: 4
  }
};
